export default __webpack_public_path__ + "static/media/SAE.7d580a58.svg";